import { changeSplash } from '@/actions/splashActions';
import {
    stateConfig,
    stateLastVisitedNotifications,
    stateNotifications,
    stateSplash,
} from '@/selectors/selectors';
import { SplashState } from '@/state/SplashState';
import { useDispatch, useSelector } from '@/state/store';
import { forwardRef, useState, useEffect } from 'react';
import { Config } from '@/bootstrap/config';
import { Feilmelding, fetchFeilmeldinger } from '@/components/notification/NotificationDialog';

const NotificationButton = forwardRef<HTMLButtonElement>((_, ref) => {
    const dispatch = useDispatch();
    const config: Config = useSelector(stateConfig);
    const splashState = useSelector(stateSplash);
    const lastVisitedState = useSelector(stateLastVisitedNotifications);
    const notificationsState = useSelector(stateNotifications).toSorted(
        (a, b) => b.time.getTime() - a.time.getTime()
    );

    const [statusAlert, setStatusAlert] = useState<Feilmelding>();

    useEffect(() => {
        fetchFeilmeldinger(config).then(res => {
            setStatusAlert(
                res
                    .filter(f => f.arsak !== 'INGEN_PROBLEMER')
                    .sort((a, b) => new Date(b.datoLaget).getTime() - new Date(a.datoLaget).getTime())[0]
            );
        });
    }, [config]);

    const iconColor = splashState === SplashState.NOTIFICATION ? 'orange' : 'inherit';
    const hasNotification = () => {
        if (statusAlert) {
            return new Date(statusAlert.datoLaget).getTime() > lastVisitedState.getTime();
        }
        return notificationsState.some(n => n.time.getTime() > lastVisitedState.getTime());
    };
    return (
        <button
            ref={ref}
            type="button"
            aria-controls="landingpage"
            aria-owns="landingpage"
            aria-label="Varsler"
            onClick={() => dispatch(changeSplash(SplashState.NOTIFICATION))}
            className="c-splash-button o-btn-square"
            title="Varsler"
        >
            <i
                className="material-icons"
                aria-hidden="true"
                style={{ color: iconColor, position: 'relative' }}
            >
                notifications
                {hasNotification() && <i className="material-icons c-notifications-circle">circle</i>}
            </i>
        </button>
    );
});

NotificationButton.displayName = 'NotificationButton';
export { NotificationButton };
